import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import api from "../../api/Api";

import {withStyles} from '@material-ui/core/styles';

function renderInput(inputProps) {
    const {classes, ref, ...other} = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: ref,
                classes: {
                    input: classes.input,
                },
                ...other,
            }}
        />
    );
}

function renderSuggestion(suggestion, {query, isHighlighted}) {
    const matches = match(suggestion.user_id.name, query);
    const parts = parse(suggestion.user_id.name, matches);
    const name = suggestion.user_id.name
    const mobileNo = suggestion.user_id.contact;
    const gender = suggestion.user_id.gender;
    const qualification = suggestion.qualification;
    return (
        <Card selected={isHighlighted} component="div" style={{margin: 0}}>
            <div style={{padding: "10px 15px"}}>
                <GridContainer key={Math.random()}>
                    <GridItem xs={6}>
                        <h4>{name}</h4>
                        <p>{qualification ? qualification + " years" : "NA"} {gender ? ", " + gender : ""}</p>
                    </GridItem>
                    <GridItem xs={6} style={{textAlign: "right"}}>
                        <h5>{mobileNo}</h5>
                    </GridItem>
                </GridContainer>
            </div>
        </Card>
    );
}

function renderSuggestionsContainer(options) {
    const {containerProps, children} = options;

    return (
        <Paper {...containerProps} square>
            {children}
        </Paper>
    );
}

const styles = theme => ({
    container: {
        flexGrow: 1,
        width: '100%',
        paddingTop: '27px',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        height: '300px'
    },
});

class IntegrationAutosuggest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            suggestions: [],
            suggestionsState: [],
            selected_doctorID: ''
        };
        this.searchClick = this.searchClick.bind(this);
        this.getSuggestions = this.getSuggestions.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getSuggestions(value) {
        {
            let inputValue = "";
            if (value) inputValue = value.trim().toLowerCase();
            let inputLength;
            if (inputValue) inputLength = inputValue.length;
            if (!(inputLength > 2))
                return [];
            var postBody = {
                "text": inputValue
            }
            return api.searchDoctors(postBody).then((result) => {
                this.setState({suggestions: result ? result.data.data : []});
                return inputLength > 2 ? this.state.suggestions.filter(doctor =>
                    doctor.user_id.name.toLowerCase().slice(0, inputLength) === inputValue
                ) : [];

            }).catch((err) => {
            })

        }

    }

    handleSuggestionsFetchRequested = ({value}) => {
        this.getSuggestions(value);
        this.setState({
            suggestions: this.getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = (event, {newValue}) => {
        this.setState({
            value: newValue,
        });
    };

    searchClick() {
        this.props.id.history.push('/')
    }

    render() {
        const {classes} = this.props;
        const {suggestions} = this.state;

        return (
            <div>
                <Autosuggest
                    theme={{
                        container: this.props.class ? this.props.class : classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderInputComponent={renderInput}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                    renderSuggestionsContainer={renderSuggestionsContainer}
                    getSuggestionValue={this.props.getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={{
                        classes,
                        placeholder: 'Add Existing Doctor',
                        value: this.state.value,
                        onChange: this.handleChange,
                        onSuggestionSelected: this.searchClick,
                    }}
                />
            </div>
        );
    }
}

IntegrationAutosuggest.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntegrationAutosuggest);



// WEBPACK FOOTER //
// ./src/components/Search/AutoCompleteComponent.jsx